export const InviteType = Object.freeze({
  company: 0,
  team: 1,
  teamMember: 2,
});
